//import { useState, useEffect } from 'react';

//import { firestoreMethods } from '../firebase/firestoreMethods';
//import { utilMethods } from '../utils/utilMethods';

//import { Link } from "react-router-dom";


function UpdateHome() {
  
  
  const handleStart = async () => {
    console.log("start");
    // Open a new window with google.com and get its tab ID
    let leftOptions = 'width=400,height=800,top=0,left=0';
    let rightOptions = 'width=1000,height=800,top=0,left=410';

    window.open('http://localhost:3000/update/1234', 'AP Controller', leftOptions);
    //window.open('http://localhost:3000/test/address');
    window.open('http://localhost:3000/test/address', 'AP Window', rightOptions);


    //let siteSteps = await firestoreMethods.getSiteSteps(openSite.id);
    var user = {
      address: {
        lineOne: "363 Bond Street",
        lineTwo: "Apt 1006",
        city: "Brooklyn",
        state: "NY", 
        zip: "11231"
      } 
    };

    var siteConfig = {
      address_url: "http://localhost:3000/test/address",
      home_url: "http://localhost:3000/test",
    };

    let message = {
      type: 'ap_host_command', 
      command: 'ap_host_start',
      user: user,
      siteConfig: siteConfig
    }
    window.postMessage(message, "*");

  }

  const handlePause = () => {
    console.log("pause");
  }

  const handleStop = () => {
    console.log("stop");
  }

  return (
    <>
      <div className='outer-box'>
        <div className='title'>
          Update Home
        </div>
        <div className='form-button-group'>
          <div className='form-button primary' id="ap_start" onClick={() => handleStart()}>Start</div> 
          <div className='form-button' id="ap_pause" onClick={() => handlePause()}>Pause</div> 
          <div className='form-button' id="ap_stop" onClick={() => handleStop()}>Stop</div> 

        </div>
      </div>
    </>
  );
}

export default UpdateHome;
